<template>
    <div class="field has-addons">
        <div class="control dropdown" ref="prefix">
            <div class="dropdown-trigger">
                <button class="button"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                        @click="toggleActive()"
                        @blur="toggleActive(false)">
                    <span v-if="current">{{ current.prefix }}</span>
                    <span class="icon is-small">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content" style="overflow: auto; max-height: 200px;">
                    <a v-for="phone of phoneArray" :class="[{ 'is-active': phone === current }, 'dropdown-item']" @click="selectPrefix(phone);">
                        <span>{{ phone.prefix }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="control column" style="display: table-cell;">
            <input :value="displayValue"
                   :class="[{ 'is-danger': errors.has($attrs['data-vv-name']) }, 'input']"
                   v-bind="$attrs"
                   v-validate="'required|phoneNumber'"
                   @input="handleInputChange"
                   ref="input" />
        </div>
    </div>
</template>

<script>
    const phoneMasks = {
        Kyivstar: ["067xxxxxxx", "098xxxxxxx", "097xxxxxxx", "096xxxxxxx", "068xxxxxxx", "088xxxxxxx", "089xxxxxxx"],
        Vodafone: ["050xxxxxxx", "095xxxxxxx", "099xxxxxxx", "066xxxxxxx", "089xxxxxxx"],
        Lifecell: ["063xxxxxxx", "093xxxxxxx", "073xxxxxxx"],
        Mtn: ["268xxxxxxxx"],
        Mgurush: ["211xxxxxxxxx"],
        Mpesa: ["254xxxxxxxxx"],
        SocnetPay: ["256xxxxxxxxx"],
    };

    export default {
        name: "phone-number",
        inject: ["$validator"],
        props: {
            inputValue: { required: true, default: "" },
            defaultValue: { required: false, default: null },
            provider: { required: true, validate: value => Object.keys(phoneMasks).some(key => key === value) }
        },
        data: function() {
            const phoneArray = phoneMasks[this.provider]
                .map(mask => {
                    const index = mask.indexOf("x");
                    const prefix = mask.substring(0, index);
                    const totalLength = prefix.length + mask.substring(index).length;
                    return { prefix, mask, totalLength, regexp: new RegExp(`\\b\\d{0,${totalLength}}`) };
                })
                .sort((item1, item2) => item1.prefix - item2.prefix);

            const current = phoneArray[0];

            return { phoneArray, current, value: `${current.prefix}${this.inputValue || this.defaultValue}` };
        },
        computed: {
            displayValue: function() {
                return this.value && this.value.replace(this.current.prefix, "");
            }
        },
        created() {
            this.$validator.extend("phoneNumber", {
                getMessage: () => this.$t("payment system.validation.phone number.format"),
                validate: value => {
                    value = `${this.current.prefix}${value}`;
                    return this.current && this.current.regexp.test(value) && value.length === this.current.totalLength;
                }
            });
        },
        mounted() {
            this.handleInputChange();
        },
        methods: {
            handleInputChange() {
                setTimeout(() => {
                    const inputValue = this.$refs.input.value.replace(/\D/g, "");
                    this.value = (this.current.prefix + inputValue).substring(0, this.current.totalLength);
                    this.$refs.input.value = this.displayValue || "";
                    this.$emit("update:inputValue", this.value);
                });
            },
            selectPrefix(phoneData) {
                this.value = (this.value ? this.value.replace(this.current.prefix, phoneData.prefix) : phoneData.prefix).substring(0, phoneData.totalLength);
                this.current = phoneData;
            },
            toggleActive(isActive) {
                const classList = this.$refs.prefix.classList;
                isActive === undefined
                    ? classList.toggle("is-active")
                    : isActive
                        ? classList.add("is-active")
                        : setTimeout(() => classList.remove("is-active"), 200);
                return true;
            }
        }
    };
</script>

<style>
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/payments/phone-number-provider.vue